import { render, staticRenderFns } from "./EasyCertificatePop.vue?vue&type=template&id=f04a836c"
import script from "./EasyCertificatePop.vue?vue&type=script&lang=js"
export * from "./EasyCertificatePop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f04a836c')) {
      api.createRecord('f04a836c', component.options)
    } else {
      api.reload('f04a836c', component.options)
    }
    module.hot.accept("./EasyCertificatePop.vue?vue&type=template&id=f04a836c", function () {
      api.rerender('f04a836c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/EasyCertificatePop.vue"
export default component.exports